import * as actionTypes from './actionTypes';
import loaded from './loaded';

export default () => (dispatch) => {
  dispatch(loaded());
  dispatch({
    type: actionTypes.GLOBAL_ERROR_DISMISSED,
  });
};
